import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import { FragmentUpdateInfo } from '@modules/Steps/Shared/Interfaces/FragmentUpdateInfo';

export const GetFragmentInfoMapForItemTypes = (
    parsedFragments: ParsedFragmentEntity[]
) => {
    const fragmentInfoMap = new Map<string, FragmentUpdateInfo>();

    parsedFragments.forEach(fragment => {
        fragment.itemTypes.forEach(itemType => {
            fragmentInfoMap.set(itemType.uuid, {
                fragment_id: fragment.id,
                fragment_index: fragment.index,
            });
        });
    });

    return fragmentInfoMap;
};
